import React from 'react';
import * as S from './CircleSpinner.styles';

const CircleSpinner = ({ bkFlt = false, isFareFamily = false }) => {
  return (
    <S.CirlcleSpinner bkFlt={bkFlt} isFareFamily={isFareFamily}>
      <S.CirlcleSpinnerInside bkFlt={bkFlt} isFareFamily={isFareFamily}></S.CirlcleSpinnerInside>
    </S.CirlcleSpinner>
  );
};

export default CircleSpinner;
